import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  canonical,
  type = 'website',
  image,
  imageAlt,
  noindex = false,
  structuredData,
  additionalMeta = []
}) => {
  const siteUrl = process.env.REACT_APP_URL || 'https://app.riskdiscover.com';
  const defaultImage = `${siteUrl}/images/riskdiscover-logo-clean.png`;
  
  const fullTitle = title 
    ? `${title} | RiskDiscover` 
    : 'RiskDiscover - AI-Powered Risk Assessment Platform';
  
  const metaDescription = description || 
    'Transform your risk assessment process with AI-powered insights. Fast, accurate, and comprehensive business risk evaluations for insurance professionals.';
  
  const canonicalUrl = canonical 
    ? `${siteUrl}${canonical}` 
    : null;
  
  const ogImage = image || defaultImage;
  const defaultImageAlt = 'RiskDiscover - AI-Powered Risk Assessment Platform Logo';
  const finalImageAlt = imageAlt || defaultImageAlt;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={finalImageAlt} />
      <meta property="og:url" content={canonicalUrl || (typeof window !== 'undefined' ? window.location.href : siteUrl)} />
      <meta property="og:site_name" content="RiskDiscover" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={finalImageAlt} />
      <meta name="twitter:site" content="@riskdiscover" />
      <meta name="twitter:creator" content="@riskdiscover" />
      
      {/* Additional Meta Tags */}
      {additionalMeta.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;